import React from 'react';
import FastbetToggle from '../betslip/fast-bet/FastbetToggle';
// import FavoriteTournaments from './FavoriteTournaments';
import CheckBox from './Checkbox';
import { useUserSettings, useUserSettingsDispatch } from '../UserSettingsProvider';
import Section from './Section';
import CheckBoxContainer from './CheckBoxContainer';
import InfoButtonContainer from './InfoButtonContainer';
import Item from './Item';
import OverlayWrapper from '../OverlayWrapper';
import { getLabel } from '../../data/labels';
import { getConfiguration } from '../../data/utils/configuration';

export default function Menu(props) {
    const conf = getConfiguration();
    const userSettings = useUserSettings();
    const userSettingsDispatch = useUserSettingsDispatch();

    return (
        <OverlayWrapper id="xs-settings-overlay">
            <div className="xs_settingsMenu z-30 absolute container top-0 left-0 right-0 bottom-0">
                <div className="min-h-full h-fit w-full bg-cs1">
                    <div className="z-20 sticky top-0 shrink-0 h-[50px] grid grid-cols-12 items-center border-b border-b-cs7 bg-cs13">
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-arrow-left font-medium text-lg text-cs1"></i>
                        </div>
                        <div className="col-start-3 col-end-13 font-medium text-lg text-cs1">{ getLabel('settings.title') ||  'Impostazioni'}</div>
                    </div>
                    <Section desc={ getLabel('settings.subtitle') || 'Generali'}>
                        <Item desc={ getLabel('settings.sliding_sport_selector') || 'Selettore sport scorrevole'}>
                            <InfoButtonContainer index={0} />
                            <CheckBoxContainer>
                                <CheckBox id="scrolling-sport-selector"
                                    checked={userSettings.scrollingSportSelector}
                                    onChange={() => userSettingsDispatch('toggleScrollingSportSelector')} />
                            </CheckBoxContainer>
                        </Item>
                        {conf.anbe &&
                            <FastbetToggle />
                        }
                        <Item desc={ getLabel('settings.social_buttons') || 'Bottoni social'}>
                            <InfoButtonContainer index={2} />
                            <CheckBoxContainer>
                                <CheckBox id="hide-social-buttons-cb"
                                        checked={userSettings.showSocialButtons}
                                        onChange={() => userSettingsDispatch('toggleShowSocialButtons')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.banners') ||  'Mostra banner'}>
                            <InfoButtonContainer index={3} />
                            <CheckBoxContainer>
                                <CheckBox id="show-banners-cb"
                                        checked={userSettings.showBanners}
                                        onChange={() => userSettingsDispatch('toggleShowBanners')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.back_to_top_arrow') ||  'Mostra freccia torna in alto'}>
                            {/* <InfoButtonContainer index={3} /> */}
                            <CheckBoxContainer>
                                <CheckBox id="show-go-to-top-btn-cb"
                                        checked={userSettings.showGoToTopButton}
                                        onChange={() => userSettingsDispatch('toggleGoToTopButton')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.info_button') || 'Mostra bottone info'}>
                            {/* <InfoButtonContainer index={3} /> */}
                            <CheckBoxContainer>
                                <CheckBox id="show-info-btn-cb"
                                        checked={userSettings.showInfoButton}
                                        onChange={() => userSettingsDispatch('toggleInfoButton')} />
                            </CheckBoxContainer>
                        </Item>
                    </Section>
                    <Section desc={ getLabel('menu.prematch') || 'Prematch'}>
                        <Item desc={ getLabel('settings.sort_category_by_name') || 'Ordina categorie per nome'}>
                            <InfoButtonContainer index={4} />
                            <CheckBoxContainer>
                                <CheckBox id="sort-categories-by-desc-cb"
                                        checked={userSettings.sortCategoriesByDesc}
                                        onChange={() => userSettingsDispatch('toggleSortCategoriesByDesc')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.featured_tournaments') || 'Mostra tornei in evidenza'}>
                            <InfoButtonContainer index={5} />
                            <CheckBoxContainer>
                                <CheckBox id="show-highlighted-tournaments-cb"
                                        checked={userSettings.showHighlightedTournaments}
                                        onChange={() => userSettingsDispatch('toggleShowHighlightedTournaments')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.live_in_prematch') || 'Mostra eventi live dentro prematch'}>
                            <InfoButtonContainer index={6} />
                            <CheckBoxContainer>
                                <CheckBox id="live-events-in-prematch-cb"
                                        checked={userSettings.showLiveEventsInPrematch}
                                        onChange={() => userSettingsDispatch('toggleshowLiveEventsInPrematch')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.dropdown_category_menu') || 'Menu categorie con menù a tendina'}>
                            <InfoButtonContainer index={7} />
                            <CheckBoxContainer>
                                <CheckBox id="show-collapsed-categories-cb"
                                        checked={userSettings.showCollapsedCategories}
                                        onChange={() => userSettingsDispatch('toggleShowCollapsedCategories')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.first_bet_only') || 'Mostra solo prima scommessa'}>
                            <InfoButtonContainer index={12} />
                            <CheckBoxContainer>
                                <CheckBox id="expanded-view-cb"
                                        checked={userSettings.showOnlyFirstBet}
                                        onChange={() => userSettingsDispatch('toggleShowOnlyFirstBet')} />
                            </CheckBoxContainer>
                        </Item>
                    </Section>
                    <Section desc={ getLabel('menu.live') || 'Live'}>
                        <Item desc={ getLabel('settings.live_categories_menu') || 'Mostra menu categorie live'}>
                            <InfoButtonContainer index={8} />
                            <CheckBoxContainer>
                                <CheckBox id="show-live-categories-cb"
                                        checked={userSettings.showLiveCategories}
                                        onChange={() => userSettingsDispatch('toggleShowLiveCategories')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.first_bet_only') || 'Mostra solo prima scommessa'}>
                            <InfoButtonContainer index={12} />
                            <CheckBoxContainer>
                                <CheckBox id="expanded-view-live-cb"
                                        checked={userSettings.showOnlyFirstBetLive}
                                        onChange={() => userSettingsDispatch('toggleShowOnlyFirstBetLive')} />
                            </CheckBoxContainer>
                        </Item>
                    </Section>
                    <Section desc={ getLabel('general.bets') || 'Scommesse'}>
                        <Item desc={ getLabel('settings.compact_bet_selector') || 'Selettore scommessa compatto'}>
                            <InfoButtonContainer index={9} />
                            <CheckBoxContainer>
                                <CheckBox id="compact-bet-selector-cb"
                                        checked={userSettings.compactBetSelector}
                                        onChange={() => userSettingsDispatch('toggleCompactBetSelector')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.bets_under_event') || 'Mostra scommesse sotto evento'}>
                            <InfoButtonContainer index={10} />
                            <CheckBoxContainer>
                                <CheckBox id="bets-under-event-cb"
                                        checked={userSettings.betsUnderEvent}
                                        onChange={() => userSettingsDispatch('toggleBetsUnderEvent')} />
                            </CheckBoxContainer>
                        </Item>
                        <Item desc={ getLabel('settings.sliding_odds') || 'Quote scorrevoli'}>
                            <InfoButtonContainer index={11} />
                            <CheckBoxContainer>
                                <CheckBox id="scrolling-odds-cb"
                                        checked={userSettings.scrollingBets}
                                        onChange={() => userSettingsDispatch('toggleScrollingBets')} />
                            </CheckBoxContainer>
                        </Item>
                    </Section>
                    {/* <FavoriteTournaments toggle={props.toggle} /> */}
                </div>
            </div>
        </OverlayWrapper>
    );
}
